module.exports = __webpack_public_path__ + "img/Login-admin.1233c195.svg";